<template>
  <el-table-column
    prop="price"
    sortable="custom"
    label="Bruttó alapár"
    show-overflow-tooltip
    min-width="140"
  >
    <template slot-scope="scope">
      {{ ((scope.row.vat && scope.row.vat.value || 27) / 100 + 1) * (scope.row.price || 0) | currency }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'price',
  };
</script>
